import React from 'react';
import BaseOverlay from 'react-bootstrap/Overlay';
import BaseOverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Fade from 'react-bootstrap/Fade';
function Overlay(props) {
  return /*#__PURE__*/React.createElement(BaseOverlay, props);
}
function OverlayTrigger(props) {
  return /*#__PURE__*/React.createElement(BaseOverlayTrigger, props, props.children);
}
Overlay.defaultProps = {
  container: undefined,
  onEnter: undefined,
  onEntered: undefined,
  onEntering: undefined,
  onExit: undefined,
  onExited: undefined,
  onExiting: undefined,
  onHide: undefined,
  placement: 'top',
  popperConfig: {},
  rootClose: false,
  rootCloseEvent: undefined,
  show: false,
  target: undefined,
  transition: Fade
};
OverlayTrigger.defaultProps = {
  defaultShow: false,
  delay: undefined,
  flip: undefined,
  onHide: undefined,
  onToggle: undefined,
  placement: undefined,
  popperConfig: {},
  show: undefined,
  target: undefined,
  trigger: ['hover', 'focus']
};
export { OverlayTrigger };
export default Overlay;